import { render } from "./AppFooter.vue?vue&type=template&id=209a6ff4&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=209a6ff4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-209a6ff4"

export default script